var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAllChats = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3622_15040)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#546BD6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2047 6H9.79525C9.58442 6.00029 9.3823 6.09026 9.23322 6.25018C9.08414 6.41011 9.00027 6.62693 9 6.85309V7.27273H16.3403C16.686 7.27321 17.0173 7.42071 17.2617 7.68288C17.5061 7.94506 17.6436 8.3005 17.6441 8.67127V14H18.2047C18.4156 13.9997 18.6177 13.9097 18.7668 13.7498C18.9159 13.5899 18.9997 13.3731 19 13.1469V6.85309C18.9997 6.62693 18.9159 6.41011 18.7668 6.25018C18.6177 6.09026 18.4156 6.00029 18.2047 6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.63559 19C8.57422 19 8.51379 18.985 8.45967 18.9562C8.40556 18.9275 8.35942 18.8859 8.32536 18.8352L7.2 17.1578C7.19804 17.1548 7.19538 17.1524 7.19226 17.1507C7.18914 17.1491 7.18565 17.1482 7.1821 17.1481H5.87702C5.76199 17.1483 5.64807 17.1259 5.54174 17.0823C5.43541 17.0388 5.33877 16.9748 5.25734 16.8941C5.1759 16.8134 5.11126 16.7176 5.0671 16.6121C5.02295 16.5066 5.00015 16.3935 5 16.2793V9.86889C5.0003 9.63854 5.09256 9.4177 5.25654 9.25482C5.42053 9.09193 5.64286 9.00029 5.87478 9H15.1252C15.3571 9.00029 15.5795 9.09193 15.7435 9.25482C15.9074 9.4177 15.9997 9.63854 16 9.86889V16.2793C15.9997 16.5096 15.9074 16.7304 15.7435 16.8933C15.5795 17.0562 15.3571 17.1479 15.1252 17.1481H10.0913C10.0878 17.1482 10.0843 17.1491 10.0812 17.1507C10.078 17.1524 10.0754 17.1548 10.0734 17.1578L8.94769 18.8352C8.91346 18.8862 8.86702 18.9279 8.81255 18.9567C8.75809 18.9854 8.69728 19.0003 8.63559 19Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3622_15040"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
export { SvgAllChats as ReactComponent };
export default __webpack_public_path__ + "87954816917324cafb09461856281afc.svg";